import NotificationsTable from './NotificationsTable';

export default NotificationsTable;
